var initScrollImg = function() {

    // init controller
    var controller = new ScrollMagic.Controller();
    $('.img__anim').each(function(i, el) {

        new ScrollMagic.Scene({triggerElement: this, offset: -300})
            .setClassToggle(this, "img__anim--reveal") // add class toggle
            .reverse(false)
            .addTo(controller);
    });

};